import { Badge, Button, Grid, Layout, Menu } from "antd";
import {
  CalendarOutlined,
  CarOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  FolderOpenOutlined,
  HistoryOutlined,
  HomeOutlined,
  SettingOutlined,
  ShopOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Can from "../Can";
import UserApp from "../../UserApp/UserApp";
import CompanyPicker from "../CompanyPicker/CompanyPicker";

const { Header, Sider, Content, Footer } = Layout;

const SideMenu = (props: any) => {
  const {
    collapsed,
    archivedCount,
    location,
    toggle,
    companies,
    currentCompany,
  } = props;
  const { useBreakpoint } = Grid;
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const screens = useBreakpoint();

  const catMenu = useRef<HTMLDivElement>(null);

  const toggleMenu = useCallback(() => {
    if (isMobile) toggle();
  }, [isMobile, toggle]);
  useEffect(() => {
    // eslint-disable-next-line eqeqeq

    const isMdBreakpoint = Object.entries(screens)
      .filter((screen) => !!screen[1])
      .filter((screen) => screen[0] === "md").length;

    setIsMobile(!isMdBreakpoint);

    if (isMdBreakpoint) {
      toggle(true);
    }
  }, [screens, setIsMobile, toggle]);

  return (
    <Sider
      ref={catMenu}
      trigger={null}
      collapsed={collapsed}
      className="dashboard__main-sider main-sider"
      theme="light"
      width={250}
      style={{
        overflow: "auto",
        height: "calc(100vh - 64px)",
        position: "fixed",
        left: isMobile && collapsed ? -80 : 0,
        top: 64,
      }}
    >
      <Menu
        mode="vertical"
        theme="light"
        defaultSelectedKeys={["/"]}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item
          key="/"
          icon={<ClockCircleOutlined style={{ fontSize: 18 }} />}
          className="menu__item"
          onClick={toggleMenu}
        >
          <Link to="/" className="nav-text">
            Dostawy oczekujące
          </Link>
        </Menu.Item>
        <Menu.Item
          key="/deliveries"
          icon={<CarOutlined style={{ fontSize: 18 }} />}
          className="menu__item"
          onClick={toggleMenu}
        >
          <Link to="/deliveries" className="nav-text">
            Dostawy realizowane
          </Link>
        </Menu.Item>

        <Menu.Item
          key="/summary"
          icon={<DollarCircleOutlined style={{ fontSize: 18 }} />}
          className="menu__item"
          onClick={toggleMenu}
        >
          <Link to="/summary" className="nav-text">
            Rozliczenia
          </Link>
        </Menu.Item>

        <Can type="is_admin" key="/users">
          <Menu.Item
            icon={<UserOutlined style={{ fontSize: 18 }} />}
            className="menu__item"
          >
            <Link to="/users" className="nav-text" onClick={toggleMenu}>
              Kierowcy
            </Link>
          </Menu.Item>
        </Can>

        <Can type="is_admin" key="/locals">
          <Menu.Item
            icon={<ShopOutlined style={{ fontSize: 18 }} />}
            className="menu__item"
          >
            <Link to="/locals" className="nav-text" onClick={toggleMenu}>
              Restauracje
            </Link>
          </Menu.Item>
        </Can>

        <Can type="is_admin" key="/settings">
          <Menu.Item
            key="/settings"
            icon={<SettingOutlined style={{ fontSize: 18 }} />}
            className="menu__item"
            onClick={toggleMenu}
          >
            <Link to="/settings" className="nav-text">
              Ustawienia
            </Link>
          </Menu.Item>
        </Can>
      </Menu>
    </Sider>
  );
};

export default SideMenu;
